import { BaseCongratulationPopup } from './BaseCongratulationPopup';

export class CongratulationsLandscapePopup extends BaseCongratulationPopup {
  execute({ root }) {
    const container = this.getPopup({ scale: 1 });
    root.addChild(container);
  }
}
